import React from 'react'
import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
   
    appbar: {
      backgroundImage: "linear-gradient( 135deg, #3B2667 10%, #BC78EC 100%)",
      
      width: "3px",
      height: "100vh",
    }
  });
function SideNavComp() {
    const classes = useStyles();
    return (
        <div className={classes.appbar}></div>
    )
}

export default SideNavComp
